import { Component, Input, OnInit } from '@angular/core';
import { IEmployee } from '../../employee';
import { IWorkTime } from '../../models/work-time';
import { WorkTimeService } from '../../services/work-time.service';
import { combineLatest,  map, tap } from 'rxjs';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { TenantSettingsStoreService } from 'src/app/setting/tenant-settings/services/tenant-settings-store.service';
import { ITenantSettings } from 'src/app/setting/tenant-settings/models/tenant-setting';
import { EmployeeStore } from 'src/app/stores/component/employee.store';
import { ActivatedRoute } from '@angular/router';
import { WorkTimesStore } from 'src/app/stores/component/work-times.store';
@UntilDestroy()
@Component({
    selector: 'app-employee-work-time',
    templateUrl: './employee-work-time.component.html',
    styleUrls: ['./employee-work-time.component.scss'],
    standalone: false
})
export class EmployeeWorkTimeComponent implements OnInit {

  constructor(
    private tenantSettingsStore: TenantSettingsStoreService,
    private employeeStore: EmployeeStore,
    private workTimesStore: WorkTimesStore
  ) { }

  public tenantSettings: ITenantSettings;
  public active = false;


  vm$ = combineLatest([
    this.employeeStore.employee$,
    this.workTimesStore.workTimes$.pipe(
      tap(workTimes => this.active = false)
    )
  ]).pipe(
    map(([
      employee,
      workTimes
    ]) => ({
      employee,
      workTimes
    }))
  );


  ngOnInit(): void {
    
    this.tenantSettingsStore.tenantSettings$
    .pipe(
      untilDestroyed(this)
    ).subscribe(
      settings => this.tenantSettings = settings
    );
  }

  // }

  addHandler({ sender }){
    this.active = true;
  }

  oncloseDialog(event = null){
    this.active = false;
  }

  hasOpenWorkTime(workTimes){
    return workTimes?.some(x => x.validTo == null)
  }

  // vacationDays wird stets auf ein 100%-Pensum erfasst. Fuers Grid rechnen wir
  // auf das effektive Pensum herunter - gleiche Formel und Rundung wie im Backend
  // (EmployeeService.CalculateVacationDays: Anteil nach Pensum, dann auf halbe Tage aufgerundet).
  vacationDaysForWorkload(workTime: IWorkTime): number {
    const vacationDays = workTime?.vacationDays ?? 0;
    const workload = workTime?.workload ?? 100;
    return Math.ceil(vacationDays * workload / 100 * 2) / 2;
  }

}
